export default {
    /*getAll(clientId) {
        return new Promise((resolve, reject) => {
            http.get(`api/clients/${clientId}/forms/`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },*/

    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post(`api/forms-templates/list`, {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAllByType(type, filterIntermediary = false) {
        const params = 'type=' + type + (filterIntermediary ? '&filter_intermediary=1' : '');
        return new Promise((resolve, reject) => {
            http.get('api/forms-templates/by-type?' + params).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveFormsTemplate(data) {
        return new Promise((resolve, reject) => {
            http.post('api/forms-templates' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteFormsTemplate(formsTemplateId) {
        return new Promise((resolve, reject) => {
            http.delete('api/forms-templates/' + formsTemplateId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    }
}
